import merchants from "../models/merchants";

const request = {}

// Global error handler - will be set from App.js
let globalErrorHandler = null;
let globalConfirmHandler = null;

request.setErrorHandler = (handler) => {
    globalErrorHandler = handler;
}

request.setConfirmHandler = (handler) => {
    globalConfirmHandler = handler;
}

const defaultOptions = {
    credentials: 'include',
    headers: {
        'Accept': 'application/json'
    }
};
const defaultUrl = '/iapi'

request.get = async (path, params = {}, displayError = false, returnErrorBody = false) => {
    const options = {...defaultOptions}
    options.method = 'GET'

    // Правильно обрабатываем множественные значения (массивы)
    const urlParams = new URLSearchParams()
    Object.keys(params).forEach(key => {
        if (Array.isArray(params[key])) {
            // Для массивов добавляем каждое значение отдельно
            params[key].forEach(value => {
                urlParams.append(key, value.toString())
            })
        } else if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
            urlParams.append(key, params[key].toString())
        }
    })
    
    const url = urlParams.toString() ? `${defaultUrl}${path}?${urlParams.toString()}` : `${defaultUrl}${path}`

    return request.send(url, options, displayError, returnErrorBody)
}
request.post = async (path, data, displayError = false) => {
    const options = {...defaultOptions}
    options.method = 'POST'
    options.body = JSON.stringify(data)
    options.headers['Content-Type'] = 'application/json'

    const url = `${defaultUrl}${path}`

    return request.send(url, options, displayError)
}
request.patch = async (path, data, displayError = false) => {
    const options = {...defaultOptions}
    options.method = 'PATCH'
    options.body = JSON.stringify(data)
    options.headers['Content-Type'] = 'application/json'

    const url = `${defaultUrl}${path}`

    return request.send(url, options, displayError)
}
request.put = async (path, data, displayError = false) => {
    const options = {...defaultOptions}
    options.method = 'PUT'
    options.body = JSON.stringify(data)
    options.headers['Content-Type'] = 'application/json'

    const url = `${defaultUrl}${path}`

    return request.send(url, options, displayError)
}
request.delete = async (path, data, displayError = false) => {
    const options = {...defaultOptions}
    options.method = 'DELETE'
    options.body = JSON.stringify(data)
    options.headers['Content-Type'] = 'application/json'

    const url = `${defaultUrl}${path}`

    return request.send(url, options, displayError)
}

request.send = async (url, options, displayError, returnErrorBody = false) => {
    try {
       let resData = await fetch(url, options);

        let ok = resData.ok;
        resData = await resData.json();

        if (Array.isArray(resData.actions) && resData.actions.length > 0) {
            actionsWorker(resData.actions)
        }

        if (!ok) {
            if (displayError) {
                if (globalErrorHandler) {
                    globalErrorHandler(resData.message || 'An error occurred');
                } else {
                    alert(resData.message || 'An error occurred');
                }
            }
            if (returnErrorBody) return resData;
            return null
        }
        return resData
    } catch (err) {
        if (displayError) {
            if (globalErrorHandler) {
                globalErrorHandler(err.message || 'An error occurred');
            } else {
                alert(err.message || 'An error occurred');
            }
        }
        return null
    }
}

const ACTION_REDIRECT = 'redirect'
const ACTION_LOGOUT = 'logout'
const ACTION_NOTIFY = 'notify'

const safeNow = () => Date.now()
const SAFE_LOGOUT_KEY = '__pg_logout_ts'
const SAFE_REDIRECT_KEY = '__pg_redirect_ts'

const spaNavigate = (to) => {
    try {
        if (typeof to !== 'string' || !to) return
        // normalize relative paths
        const next = to.startsWith('http') ? to : to.startsWith('/') ? to : `/${to}`
        if (next.startsWith('http')) {
            // external navigation => full redirect
            window.location.href = next
            return
        }
        const current = `${window.location.pathname}${window.location.search}${window.location.hash}`
        if (current === next) return
        window.history.pushState({}, '', next)
        window.dispatchEvent(new PopStateEvent('popstate'))
    } catch (e) {
        window.location.href = to
    }
}

const actionsWorker = (actions) => {
    actions.forEach((action) => {
        switch (action.type) {
            case ACTION_REDIRECT:
                if (typeof action.to === 'string' && action.to) {
                    // prevent infinite loops (backend can spam redirect on 403)
                    try {
                        const lastTs = parseInt(sessionStorage.getItem(SAFE_REDIRECT_KEY) || '0', 10)
                        if (!lastTs || safeNow() - lastTs > 500) {
                            sessionStorage.setItem(SAFE_REDIRECT_KEY, String(safeNow()))
                            spaNavigate(action.to)
                        }
                    } catch (e) {
                        spaNavigate(action.to)
                    }
                }
                break;
            case ACTION_LOGOUT:
                try {
                    const lastTs = parseInt(sessionStorage.getItem(SAFE_LOGOUT_KEY) || '0', 10)
                    // if backend keeps sending logout, don't loop-reload the page
                    if (!lastTs || safeNow() - lastTs > 2000) {
                        sessionStorage.setItem(SAFE_LOGOUT_KEY, String(safeNow()))
                        merchants.logout()
                        spaNavigate('/')
                    }
                } catch (e) {
                    merchants.logout()
                    spaNavigate('/')
                }
                break;
            case ACTION_NOTIFY:
                // If backend uses notify actions, use error handler if available
                if (action.message) {
                    if (globalErrorHandler) {
                        globalErrorHandler(action.message);
                    } else {
                        alert(action.message);
                    }
                }
                break;
            default:
                break;
        }
    })
}

export default request